import { createIcon } from './createIcon'


export const CheckIcon = createIcon({
    d: 'M21.0157 5.41301C21.4062 5.80353 21.4062 6.4367 21.0157 6.82722L10.0157 17.8272C9.62518 18.2177 8.99201 18.2177 8.60149 17.8272L3.60149 12.8272C3.21096 12.4367 3.21096 11.8035 3.60149 11.413C3.99201 11.0225 4.62518 11.0225 5.0157 11.413L9.30859 15.7059L19.6015 5.41301C19.992 5.02249 20.6252 5.02249 21.0157 5.41301Z',
    displayName: 'CheckIcon',
    viewBox: '0 0 25 25',
})
